const Storage = require('utilities/storage');
import { formatText } from 'core/i18n';
const iconPositionUrl = require('../../../assets/icons/map/icon-position.png');
const iconGeolocationUrl = require('../../../assets/icons/map/icon-geo.png');
const iconPinUrl = require('../../../assets/icons/map/icon-pin.png');
const iconPinSelectedUrl = require('../../../assets/icons/map/icon-pin-selected.png');

const deg2rad = deg => {
    return deg * (Math.PI / 180);
};

const getDistanceFromLatLonInKm = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d.toFixed(2);
};

const getDaysDelay = postalCode => {
    let days = 2;
    if (postalCode.startsWith('07')) {
        days = 3;
    }
    if (
        postalCode.startsWith('35') ||
        postalCode.startsWith('38') ||
        postalCode.startsWith('51') ||
        postalCode.startsWith('52')
    ) {
        days = 4;
    }

    return days;
};

const handleMyPositionIcon = geolocation => {
    return geolocation ? iconGeolocationUrl : iconPositionUrl;
};

const handleGeocoder = (address, callback) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
            const latitude = results[0].geometry.location.lat();
            const longitude = results[0].geometry.location.lng();
            callback(latitude, longitude);
        }
    });
};

const handleMarkerIcon = marker => {
    const iconPin = {
        anchor: new google.maps.Point(15, 38),
        scaledSize: new google.maps.Size(30, 38),
        url: encodeURI(iconPinUrl),
    };

    const iconPinSelected = {
        anchor: new google.maps.Point(22, 61),
        scaledSize: new google.maps.Size(45, 61),
        url: encodeURI(iconPinSelectedUrl),
    };

    return marker.openInfoWindow ? iconPinSelected : iconPin;
};

const handleCenterMapHelper = (mapCenter, myInitialPosition = false) => {
    mapCenter.lat = parseFloat(mapCenter.lat.toFixed(7));
    mapCenter.lng = parseFloat(mapCenter.lng.toFixed(7));

    if (myInitialPosition) {
        return {
            centerChanged: true,
            center: mapCenter,
            myPosition: mapCenter,
        };
    }

    return {
        centerChanged: true,
        center: mapCenter,
    };
};

const handleMarkersHelper = (props, state) => {
    const { map } = props;
    const { markers, myPosition } = state;
    const branches = map.get('branches');
    const handleCondition = !(markers.length === 0 && !branches.isEmpty());
    let newMarkers = [];
    if (!handleCondition) {
        newMarkers = branches.map((value, index) => {
            const postOffice = value.toObject();
            if (!postOffice.nombre.toLowerCase().startsWith('eo')) {
                if (!postOffice.nombre.toLowerCase().startsWith('estafeta')) {
                    const lat1 = myPosition.lat;
                    const lng1 = myPosition.lng;
                    const lat2 = postOffice.latitudWGS84;
                    const lng2 = postOffice.longitudWGS84;
                    const distance = getDistanceFromLatLonInKm(lat1, lng1, lat2, lng2);

                    const days = getDaysDelay(postOffice.cp);
                    const description =
                        days === 4
                            ? formatText('identity-officeDays2', [days])
                            : formatText('identity-officeDays1', [days * 24]);

                    const postOfficeHours3Service = postOffice.horarioF.replace('DE ', '').toLowerCase();
                    const postOfficeHours3 =
                        Storage.cookies.get('language') === 'en' && postOfficeHours3Service === 'sin servicio'
                            ? 'no service'
                            : postOfficeHours3Service;

                    return {
                        position: {
                            lat: postOffice.latitudWGS84,
                            lng: postOffice.longitudWGS84,
                        },
                        key: index,
                        defaultAnimation: 2,
                        unidad: postOffice.unidad,
                        title: postOffice.nombre,
                        description: description,
                        distance: distance.toString() + ' Km',
                        address: postOffice.direccion + ', ' + postOffice.cp + ', ' + postOffice.descLocalidad,
                        postalCode: postOffice.cp,
                        phone: postOffice.telefono.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4'),
                        officeHours1: postOffice.horarioLV.replace('DE ', '').toLowerCase(),
                        officeHours2: postOffice.horarioS.replace('DE ', '').toLowerCase(),
                        officeHours3: postOfficeHours3,
                        daysDelay: days,
                        openInfoWindow: false,
                    };
                }
            }
        });
    }

    const outputMarkers = Array.isArray(newMarkers) ? newMarkers : newMarkers.toJSON();
    const validMarkers = outputMarkers.filter(marker => marker !== undefined);
    return validMarkers;
};

export default {
    handleMyPositionIcon,
    handleGeocoder,
    handleMarkerIcon,
    handleCenterMapHelper,
    handleMarkersHelper,
};
